// Copyright (c) 2017 Deere & Company

import './index.scss';
import * as helpers from './helpers';
import React, {
    Component,
    PropTypes
} from 'react';
import FacetFilter from '../facet-filter/';
import ProductLevel from './product-level';

class ProductHierarchy extends Component {

    state = {
        products: this.props.productHierarchy.productHierarchy,
        selectedProduct: this.props.selectedProductCode
    };

    /* istanbul ignore next */

    getChildContext() {

        return {
            onProductHierarchyChange: newSelectedProduct => {

                this.props.onProductHierarchyChange(newSelectedProduct);
                this.setState({
                    selectedProduct: newSelectedProduct
                });

            }
        };

    }

    componentWillReceiveProps(nextProps) {

        if (this.props.productHierarchy !== nextProps.productHierarchy) {

            this.setState({
                products: nextProps.productHierarchy.productHierarchy
            });

        }

        if (this.props.selectedProductCode !== nextProps.selectedProductCode) {

            this.setState({
                selectedProduct: nextProps.selectedProductCode
            });

        }

    }

    handleFilterChange = text => {

        const textToSearch = new RegExp(text, 'i');

        const filteredProductHierarchy = helpers.filterProductHierarchy(textToSearch, this.props.productHierarchy.productHierarchy);

        this.setState({
            products: filteredProductHierarchy
        });

    };

    render = () =>
        <section className='product-hierarchy'>
            <FacetFilter
                onFilterChange={this.handleFilterChange}
                placeholder={this.props.filterPlaceholder}
            />
            <ProductLevel
                products={this.state.products}
                selectedProduct={this.state.selectedProduct}
            />
        </section>;

}

ProductHierarchy.displayName = 'ProductHierarchy';
ProductHierarchy.propTypes = {
    filterPlaceholder: PropTypes.string.isRequired,
    onProductHierarchyChange: PropTypes.func,
    productHierarchy: PropTypes.object.isRequired,
    selectedProductCode: PropTypes.string.isRequired
};
ProductHierarchy.childContextTypes = {
    onProductHierarchyChange: PropTypes.func.isRequired
};

export default ProductHierarchy;



// WEBPACK FOOTER //
// ./src/shared/components/facets/product-hierarchy/index.js